import { themeStyle } from '@src/theming';
import styled from 'styled-components';

import { BadgeProps } from './types';

const rounds = {
  xs: '4px',
  full: '10000px',
};

const backgrounds = {
  main: themeStyle.varInkMain,
  highlight: themeStyle.varHighlight,
  red: themeStyle.varRedMain,
  blue: themeStyle.varBlueLight,
  brand: themeStyle.varBrandLight,
  disabled: themeStyle.varInkLight,
};

export const fontColors = {
  main: themeStyle.varBackgroundAlt,
  highlight: themeStyle.varBackgroundAlt,
  red: themeStyle.varBackgroundAlt,
  blue: themeStyle.varBlueMain,
  brand: themeStyle.varInkMain,
  disabled: themeStyle.varInkMedium,
};

const paddings = {
  s: '2px 8px',
  m: '6px 8px',
};

const heights = {
  s: '20px',
  m: '24px',
};

export const BadgeContainer = styled.div<Omit<Required<BadgeProps>, 'text'>>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: fit-content;

  max-width: ${({ maxWidth }) => maxWidth};
  height: ${({ size }) => heights[size]};
  padding: ${({ size }) => paddings[size]};
  border-radius: ${({ round }) => rounds[round]};
  background-color: ${({ variant }) => backgrounds[variant]};
  text-decoration: ${({ textStrikeThrough }) =>
    textStrikeThrough ? 'line-through' : 'none'};
  text-decoration-color: ${({ variant }) => fontColors[variant]};
`;
